import "./styles.scss";
import FramedButton from "../../components/FramedButton/FramedButton";
import { heroSection } from "../../texts";

const Hero = () => {
  return (
    <section id="Hero" className="introSection">
      <div className="heroContainer">
        <div>
          <div className="cursive">{heroSection.title1}</div>
          <h1 className="title">{heroSection.title2}</h1>
          <div className="title secondary">{heroSection.title3}</div>
          <div className="textContainer">
            <p className="heroParagraph">
              {heroSection.paragraph1}
              <br></br>
              {heroSection.paragraph2}
            </p>
          </div>
        </div>
        <FramedButton text={heroSection.buttonText} />
      </div>
    </section>
  );
};

export default Hero;
